/**
 * Update content displaying for individual tours
 * @author Matt Haynes
 * @package Dunfermline
 */

import AudioPlayer from './AudioPlayer';

const updateContent = (
    tourData,
    pageData,
    tourContent,
    currentDisplay,
    isFirstPageLoad = false
) => {
    // Set next / prev buttons disabled state
    const nextTour = document.querySelectorAll('.next-tour');
    const prevTour = document.querySelectorAll('.prev-tour');
    if (currentDisplay === tourData.length - 1) {
        nextTour.forEach((elem) => {
            elem.disabled = true;
        });
    } else {
        nextTour.forEach((elem) => {
            elem.disabled = false;
        });
    }
    if (currentDisplay === 0) {
        prevTour.forEach((elem) => {
            elem.disabled = true;
        });
    } else {
        prevTour.forEach((elem) => {
            elem.disabled = false;
        });
    }

    const tourName = tourData[0].type;

    // Set active Marker
    // eslint-disable-next-line
    const markerList = Array.from(document.querySelectorAll('.marker'));
    markerList.forEach((marker) => {
        if (marker.classList.contains(`marker_${currentDisplay}`)) {
            marker.classList.add('active');
        } else {
            marker.classList.remove('active');
        }
    });

    // Set class list up for visited button state
    const visitedArr =
        (localStorage.getItem(`visitedItems-${tourName}`) &&
            localStorage
                .getItem(`visitedItems-${tourName}`)
                .split(',')
                .sort()) ||
        [];
    const visitedButton = document.getElementById('visited');
    const hasBeenVisited =
        visitedArr.length > 0 &&
        visitedArr.indexOf(currentDisplay.toString()) > -1;
    if (hasBeenVisited) {
        visitedButton.classList.add('visited');
    } else {
        visitedButton.classList.remove('visited');
    }

    // Create + display content
    const { title, content, _embedded, acf } = tourData[currentDisplay];
    const {
        subheading,
        nearby_amenities: nearbyAmenities,
        spotify_library_uri: spotifyUri,
        audio_file: audioFile,
        pin_order: pinOrder,
    } = acf;
    const contentArea = tourContent;

    const spotifyPlayer = document.getElementById('spotify-player');
    if (spotifyPlayer) {
        if (spotifyUri) {
            spotifyPlayer.setAttribute('data-src', spotifyUri);
            spotifyPlayer.querySelector(
                'iframe'
            ).src = `https://open.spotify.com/embed/playlist/${spotifyUri}`;
            if (!isFirstPageLoad) spotifyPlayer.classList.remove('hide');
        } else {
            spotifyPlayer.setAttribute('data-src', '');
            spotifyPlayer.classList.add('hide');
        }
    }

    const audioContainer = document.getElementById('audio-container');

    if (audioContainer) {
        if (audioFile) {
            AudioPlayer(audioFile);
            audioContainer.classList.remove('hide');
            audioContainer.classList.remove('init-hide');
        } else {
            audioContainer.classList.add('hide');
        }
    }

    const continueTour = document.getElementById('continue');
    const tourSlug = tourData[currentDisplay].slug;
    if (window.location.hash !== `#${tourSlug}` && !isFirstPageLoad) {
        window.history.pushState(null, null, `#${tourSlug}`);
    }
    continueTour.addEventListener('click', () => {
        window.history.pushState(null, null, `#${tourSlug}`);
    });

    const nearbyAmenitiesTitle =
        nearbyAmenities.length > 0 ? '<h3>Nearby</h3>' : '';
    const amenities =
        nearbyAmenities &&
        nearbyAmenities
            .map((amenity) => {
                const {
                    website_amenity: webLink,
                    type_of_amenity: typeOfAmenity,
                    description,
                    distance,
                } = amenity;
                const website =
                    webLink && webLink.length > 0
                        ? `| <a class='amenity__amenity-website' href='${webLink}' target='_blank'> Website</a>`
                        : '';
                return `
                <div class="amenity">
                    <span class="amenity__image bg-med">
                        <img src="/wp-content/themes/dunfermline/images/amenities/${typeOfAmenity}.svg" alt="" />
                    </span>
                    <div class="amenity__desc-type">
                        <span class="amenity__description">${description}</span>
                        <span class="amenity__amenity-type  col-light">
                            ${typeOfAmenity}
                            ${website}
                        </span>
                    </div>
                    <span class="amenity__distance">${distance}</span>                    
                </div>
            `;
            })
            .join('');

    contentArea.innerHTML = ''; // reset tourContent to empty before populating

    const mediumLargeImage =
        _embedded?.['wp:featuredmedia']?.[0]?.media_details?.sizes?.medium_large
            ?.source_url;
    const mediumImage =
        _embedded?.['wp:featuredmedia']?.[0]?.media_details?.sizes?.medium
            ?.source_url;
    const featuredImage = mediumLargeImage || mediumImage;

    if (featuredImage)
        contentArea.innerHTML = `<div class="header-image test" style="background-image: url(${featuredImage})"> </div>`;

    contentArea.innerHTML += `
        <h1>${title.rendered}</h1>
        <span class="tour-content__seeMore">See more information</span>
        <h2 class="tour-content__subheading">${subheading}</h2>
        <div class="content">${content.rendered}</div>
        <div class="amenities">
            ${nearbyAmenitiesTitle}
            ${amenities || ''}
        </div>
    `;
};

export default updateContent;
